export { default as ModuleDetail } from "./ModuleDetail";
